import stripeHandler from './stripeHandler.js';
import modalHandler from './modalHandler.js';
import liveUpdate from './liveUpdate.js';
import missingImgHandler from './missingImgHandler.js';


$(window).on('load', () => {

  //Disables autoscroll to last position on reload
  if (history && 'scrollRestoration' in history) history.scrollRestoration = 'manual';

  //Scrolls to the top of the page to show any updates
  $(window).scrollTop(0);
  
  // console.log('main.js heard doc ready event');
  const orderExists = document.getElementById('orderExists').getAttribute('data-value') === 'true';
  if (orderExists) {
    const infoElement = document.getElementById('order-info-hidden');

    const status = infoElement.getAttribute('data-status');
    const token = infoElement.getAttribute('data-token');
    const stripePublicKey = infoElement.getAttribute('data-stripe-public-key');

    missingImgHandler();
    modalHandler();
    if (status == 'sent') stripeHandler(stripePublicKey);
    liveUpdate(token);
  };
});






// WEBPACK FOOTER //
// ./public/src/main.js